import * as React from "react";
import { Affix, Row, Col, Card, List, Badge, Button, Tabs, Form, Input, Tag, Typography, Space } from "antd";

import { PageHeader } from "antd";

import "../../../assets/profile.css";

const Profile = (props) => {
    return (
        <>
            <PageHeader
                className="m-b-10"
                onBack={props.onBack}
                title={props.mainTitle}
                subTitle={props.mainSubtitle}
                extra={props.mainExtra || []}
            />
            <Row>
                <Col xs={24}>
                    <Card bordered={false} className="profile-details">
                        <Row>
                            <Col sm={10} md={8} xl={4} style={{ padding: "10px 5px" }}>
                                {props.renderInformation && props.renderInformation()}
                            </Col>
                            <Col sm={14} md={16} xl={20} style={{ padding: "10px 5px" }}>
                                {props.children}
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default Profile;
